// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Shared document-preview modal — used by the doc list and the upload
   queue. Themed via inherited CSS variables from the Main Shell. */

.doc-preview-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}

.doc-preview {
  background: var(--color-surface-light);
  border-radius: 12px;
  width: 90vw;
  height: 85vh;
  max-width: 1200px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

.doc-preview__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid var(--color-surface-dark);
  flex-shrink: 0;
}

.doc-preview__title-group {
  min-width: 0;
  flex: 1;
}

.doc-preview__title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: var(--color-primary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.doc-preview__meta {
  font-size: 12px;
  color: var(--color-text-secondary);
}

.doc-preview__header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: 16px;
  flex-shrink: 0;
}

.doc-preview__download {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  border: 1px solid rgba(76, 106, 88, 0.3);
  border-radius: 6px;
  background: var(--color-surface-light);
  color: var(--color-secondary);
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s, color 0.15s;
  white-space: nowrap;
}

.doc-preview__download:hover {
  background: rgba(76, 106, 88, 0.08);
  border-color: var(--color-secondary);
}

.doc-preview__download svg {
  flex-shrink: 0;
}

.doc-preview__close {
  width: 32px;
  height: 32px;
  border: 1px solid var(--color-surface-dark);
  border-radius: 8px;
  background: var(--color-surface-light);
  color: var(--color-text-secondary);
  font-size: 20px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s, color 0.15s;
  line-height: 1;
}

.doc-preview__close:hover {
  background: var(--color-surface-dark);
  color: var(--color-primary);
}

.doc-preview__body {
  flex: 1;
  overflow: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--color-surface-light);
}

.doc-preview__iframe {
  width: 100%;
  height: 100%;
  border: none;
}

.doc-preview__image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  padding: 16px;
}

.doc-preview__error,
.doc-preview__loading {
  padding: 24px;
  color: var(--color-text-secondary);
  font-size: 14px;
}

/* Mobile — modal fills the viewport so nothing chrome-related steals
   space, and the label on the download button collapses to icon-only
   to keep the header compact. */
@media (max-width: 767px) {
  .doc-preview {
    width: 100vw;
    height: 100vh;
    max-width: 100vw;
    border-radius: 0;
  }

  .doc-preview__header {
    padding: 12px 16px;
  }

  .doc-preview__download-label {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/DocumentPreview.css"],"names":[],"mappings":"AAAA;mEACmE;;AAEnE;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,kDAAkD;EAClD,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,OAAO;AACT;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,wCAAwC;EACxC,kBAAkB;EAClB,sCAAsC;EACtC,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,6DAA6D;EAC7D,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;AACtC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2CAA2C;EAC3C,kBAAkB;EAClB,sCAAsC;EACtC,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,OAAO;EACP,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;AACf;;AAEA;;EAEE,aAAa;EACb,kCAAkC;EAClC,eAAe;AACjB;;AAEA;;gCAEgC;AAChC;EACE;IACE,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["/* Shared document-preview modal — used by the doc list and the upload\n   queue. Themed via inherited CSS variables from the Main Shell. */\n\n.doc-preview-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.6);\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n}\n\n.doc-preview {\n  background: var(--color-surface-light);\n  border-radius: 12px;\n  width: 90vw;\n  height: 85vh;\n  max-width: 1200px;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n}\n\n.doc-preview__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 20px;\n  border-bottom: 1px solid var(--color-surface-dark);\n  flex-shrink: 0;\n}\n\n.doc-preview__title-group {\n  min-width: 0;\n  flex: 1;\n}\n\n.doc-preview__title {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--color-primary);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.doc-preview__meta {\n  font-size: 12px;\n  color: var(--color-text-secondary);\n}\n\n.doc-preview__header-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-left: 16px;\n  flex-shrink: 0;\n}\n\n.doc-preview__download {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 10px;\n  border: 1px solid rgba(76, 106, 88, 0.3);\n  border-radius: 6px;\n  background: var(--color-surface-light);\n  color: var(--color-secondary);\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.15s, border-color 0.15s, color 0.15s;\n  white-space: nowrap;\n}\n\n.doc-preview__download:hover {\n  background: rgba(76, 106, 88, 0.08);\n  border-color: var(--color-secondary);\n}\n\n.doc-preview__download svg {\n  flex-shrink: 0;\n}\n\n.doc-preview__close {\n  width: 32px;\n  height: 32px;\n  border: 1px solid var(--color-surface-dark);\n  border-radius: 8px;\n  background: var(--color-surface-light);\n  color: var(--color-text-secondary);\n  font-size: 20px;\n  font-weight: 500;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background 0.15s, color 0.15s;\n  line-height: 1;\n}\n\n.doc-preview__close:hover {\n  background: var(--color-surface-dark);\n  color: var(--color-primary);\n}\n\n.doc-preview__body {\n  flex: 1;\n  overflow: auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--color-surface-light);\n}\n\n.doc-preview__iframe {\n  width: 100%;\n  height: 100%;\n  border: none;\n}\n\n.doc-preview__image {\n  max-width: 100%;\n  max-height: 100%;\n  object-fit: contain;\n  padding: 16px;\n}\n\n.doc-preview__error,\n.doc-preview__loading {\n  padding: 24px;\n  color: var(--color-text-secondary);\n  font-size: 14px;\n}\n\n/* Mobile — modal fills the viewport so nothing chrome-related steals\n   space, and the label on the download button collapses to icon-only\n   to keep the header compact. */\n@media (max-width: 767px) {\n  .doc-preview {\n    width: 100vw;\n    height: 100vh;\n    max-width: 100vw;\n    border-radius: 0;\n  }\n\n  .doc-preview__header {\n    padding: 12px 16px;\n  }\n\n  .doc-preview__download-label {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
